import { render, staticRenderFns } from "./MassTextBox.vue?vue&type=template&id=5f4bd160&scoped=true&"
import script from "./MassTextBox.vue?vue&type=script&lang=js&"
export * from "./MassTextBox.vue?vue&type=script&lang=js&"
import style0 from "./MassTextBox.vue?vue&type=style&index=0&id=5f4bd160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4bd160",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/bikrampahi/Projects/upwork/5 Brian/sndle.io/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VCheckbox,VContainer,VFlex,VIcon,VLayout})
